import { memo } from 'react';
import { CardManagementTemplate } from 'components/templates/CardManagementTemplate';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from 'components/templates/override.module.scss';
import { usePayPalClientId } from 'hooks/payment/UsePayPalClientId';
import { usePayPalClientToken } from 'hooks/payment/UsePayPalClientToken';

type Props = {};

export const CardManagement = memo((_props: Props) => {
	const { clientId, loading } = usePayPalClientId();
	const { clientTokenResData, getClientTokenLoading } = usePayPalClientToken();

	if (loading || getClientTokenLoading) {
		return (
			<Backdrop className={classes.backdrop} open={loading || getClientTokenLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
		);
	}

	return (
		<PayPalScriptProvider
			options={{
				'client-id': clientId,
				vault: true,
				components: 'buttons,hosted-fields',
				intent: 'tokenize',
				currency: 'JPY',
				'data-namespace': 'paypal_sdk_card_management',
				'data-client-token': clientTokenResData.paypal_client_token,
			}}
		>
			<CardManagementTemplate />
		</PayPalScriptProvider>
	);
});
